export const initialState = {
  barPos: 0,
  barWidth: 0,
  isHidden: true,
  mouseX: null,
  touchX: null,
  padding: 0,
  startingPos: 0,
}

export enum ActionType {
  BarScroll = 'BAR_SCROLL',
  BarScrollInit = 'BAR_SCROLL_INIT',
  BarScrollReset = 'BAR_SCROLL_RESET',
  CarouselScroll = 'CAROUSEL_SCROLL',
  Resize = 'RESIZE',
}

type State = {
  barPos: number
  barWidth: number
  isHidden: boolean
  mouseX: number | null
  padding: number
  startingPos: number
  touchX: number | null
}

type Action = {
  type: ActionType
  payload?: {
    barPos?: number
    barWidth?: number
    isHidden?: boolean
    mouseX?: number | null
    padding?: number
    startingPos?: number
    touchX?: number | null
  }
}

export const reducer = (state: State, action: Action) => {
  switch (action.type) {
    case ActionType.BarScroll:
    case ActionType.BarScrollInit:
    case ActionType.CarouselScroll:
    case ActionType.Resize:
      return { ...state, ...action.payload }
    case ActionType.BarScrollReset:
      return {
        ...state,
        mouseX: initialState.mouseX,
        startingPos: initialState.startingPos,
        touchX: initialState.touchX,
      }
    default:
      throw new Error()
  }
}
